/**
 * @deprecated - compose functions instead of passing callbacks
 *
 * @description gets value from an object based on the given key string or function
 *
 * @param {*} obj
 * @param {(string | Function)} getBy
 * @return {*}  {string}
 *
 * @example
 * getValueFromObject({ a: { b: 2 } }, 'a');
 * // returns {b:2}
 *
 */
export var getValueFromObject = function (obj, getBy) {
    if (typeof getBy === 'string')
        return obj[getBy];
    if (typeof getBy === 'function')
        return getBy(obj);
    return null;
};
//# sourceMappingURL=getValueFromObject.js.map